/* global DP_IS_ENTERPRISE */
import { getObjConfig } from '@webapp-next/lib/session';
import { tabHighlight, showSideTeamStatusBar, linkRunner } from './helpers';
import {
  createWebappRoute,
  getCurrentRoute,
  getCurrentRouteParams,
} from '../helpers';

export default [
  createWebappRoute({
    path: '/report',
    name: 'report-module',
    component() {
      console.log('ROUTER, report');

      const { path } = getCurrentRoute();

      if (getObjConfig()?.IsFreemium) {
        $dt.toggleFreemiumUpgradeModal('template-reports');
        return false;
      }

      showSideTeamStatusBar(false);
      $dt?.rtrMain?.setAIAffectsContent?.(true);
      tabHighlight('report');

      if (path) {
        $dt.rtrRPGoto = path;
      }
    },
  }),
  createWebappRoute({
    path: '/report/:submodule',
    name: 'report-module-submodule',
    component() {
      console.log('ROUTER, report');

      const { path } = getCurrentRoute();
      const { submodule } = getCurrentRouteParams();

      if (getObjConfig()?.IsFreemium) {
        $dt.toggleFreemiumUpgradeModal('template-reports');
        return false;
      }

      showSideTeamStatusBar(false);
      $dt?.rtrMain?.setAIAffectsContent?.(true);
      tabHighlight('report');

      if (path) {
        $dt.rtrRPGoto = path;
      }

      // TODO: remove this exposed variable because it's already implemented here DP_SUBSCRIPTION
      if (DP_IS_ENTERPRISE) {
        if (submodule) {
          linkRunner($('#container-report #' + submodule.replace(/^\//, '')));
          $('#container-report').hide();
        }
      }
    },
  }),
];
